import React from 'react';
import { List, Avatar, Tag, Space, Typography, Button } from 'antd';
import { EditOutlined, DeleteOutlined, ExperimentOutlined } from '@ant-design/icons';
import { Adaptation } from '../../types';
import { getCategoryColor } from '../utils/adaptationUtils';

const { Text, Paragraph } = Typography;

interface AdaptationListProps {
  adaptations: Adaptation[];
  onEdit: (adaptation: Adaptation) => void;
  onDelete: (adaptation: Adaptation) => void;
}

const AdaptationList: React.FC<AdaptationListProps> = ({
  adaptations,
  onEdit,
  onDelete,
}) => {
  return (
    <List
      dataSource={adaptations}
      renderItem={(adaptation) => (
        <List.Item
          actions={[
            <Button
              key="edit"
              type="text"
              icon={<EditOutlined />}
              onClick={() => onEdit(adaptation)}
            >
              Edit
            </Button>,
            <Button
              key="delete"
              type="text"
              icon={<DeleteOutlined />}
              danger
              onClick={() => onDelete(adaptation)}
            >
              Delete
            </Button>,
          ]}
        >
          <List.Item.Meta
            avatar={
              <Avatar 
                style={{ backgroundColor: getCategoryColor(adaptation.category) }}
                icon={<ExperimentOutlined />}
              />
            }
            title={
              <Space>
                {adaptation.name}
                <Tag color={getCategoryColor(adaptation.category)}>
                  {adaptation.category}
                </Tag>
              </Space>
            }
            description={
              <div>
                <Paragraph ellipsis={{ rows: 2, expandable: true }}>
                  {adaptation.description}
                </Paragraph>
                <Space wrap style={{ marginTop: 8 }}>
                  <Text type="secondary">
                    {adaptation.scientificParameters.length} parameters
                  </Text>
                  <Text type="secondary">
                    {adaptation.exerciseAssociations.length} exercise associations
                  </Text>
                </Space>
              </div>
            }
          />
        </List.Item>
      )}
    />
  );
};

export default AdaptationList; 